import deepesh from '../public/deepesh.png'
import aditya from '../public/aditya.jpg'
import shivam from '../public/Shivam.jpg'
import darryl from '../public/Darryl.jpg'
import nimish from '../public/Nimish.jpg'
export const AppDevelopment = [
    {
        id: 1,
        name: 'Deepesh Bansal',
        image_url:deepesh,
        description : 'App Development',       
    },
    {
        id:2,
        name:'Aditya Lahane',
        image_url:aditya,
        description:'App Development'
    },
    {
        id:3,
        name:'Shivam Sharma',
        image_url:shivam,
        description:'App Development'
    },
    {
        id:4,
        name:'Darryl Arun David',
        image_url:darryl,
        description:'App Development'
    },
    {
        id:5,
        name:'Nimish Natani',
        image_url:nimish,
        description:'App Development'
    }
]
